import { render, staticRenderFns } from "./update_phone.vue?vue&type=template&id=61f07167&scoped=true&"
import script from "./update_phone.vue?vue&type=script&lang=js&"
export * from "./update_phone.vue?vue&type=script&lang=js&"
import style0 from "./update_phone.vue?vue&type=style&index=0&id=61f07167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f07167",
  null
  
)

export default component.exports